import { Component, OnInit } from '@angular/core';
import { Lab_Interface } from 'src/app/Interface/Lab_Interface';
import { LabService } from 'src/app/Service/Lab/Lab.service';
import { NavService } from 'src/app/Service/Nav/Nav.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-LabCertificate',
  templateUrl: './LabCertificate.component.html',
  styleUrls: ['./LabCertificate.component.scss']
})
export class LabCertificateComponent implements OnInit {
  QRCodeInput:String=""
  page:number=0;
  Procssing:boolean=false;
  InProccessing:boolean=false;
  modalRef_Download: any;
  modalRef_Upload: any;
  BaseUrl:string=environment.BaseUrl;

  DataList_Lab:Array<Lab_Interface>=[]
  constructor(
    private Lab_Service:LabService,
    private Nav_Service:NavService,
  ) { }

  ngOnInit() {
    this.Nav_Service.CheckValidPage(1092).subscribe(
      data=>{
        this.ReadData_Lab()
      }
      ,error=>{
        // AuthInterceptor owns authentication; feature errors must preserve credentials.
      }
    )


  }



  ReadData_Lab(){
    this.Procssing=true
    this.Lab_Service.GetLabCertificate().subscribe(
      data=>{


        this.DataList_Lab=data
        this.Procssing=false


      },error=>{
        // AuthInterceptor owns authentication; feature errors must preserve credentials.

      }
    )
  }






}
